export const MENU_IS_ACTIVE = 'MENU_IS_ACTIVE';

export const ACTIVE_MENU_ITEM = 'ACTIVE_MENU_ITEM';

export const ACTIVE_MENU_ITEMS = 'ACTIVE_MENU_ITEMS';

export const SEARCH_IS_ACTIVE = 'SEARCH_IS_ACTIVE';
